import React from "react";

export default function LogoName() {
  return (
    <div>
      <h1 style={{ fontSize: "24px", letterSpacing: "2.88px" }}>Moshe Dayan</h1>
    </div>
  );
}
